export const COUNTERS_GET = 'COUNTERS_GET';
export const VISITS_GET = 'VISITS_GET';
export const WEBTRACKING_INFOBOX_TOGGLE = 'WEBTRACKING_INFOBOX_TOGGLE';
